import { createContext } from "react"
import IAssignment from "../models/IAssignment"
import { Action } from "../reducers/ConsultantsReducer";

export const initialAssignments: IAssignment[] = [];

export const AssignmentsContext = 
    createContext<{state: typeof initialAssignments; dispatch: (action: Action) => void}>({ state: initialAssignments, dispatch: () => {} });